module.exports = __webpack_public_path__ + "img/over_sla_status.10a7255f.svg";